"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const siteText_1 = tslib_1.__importDefault(require("../../mixins/siteText"));
const sitetext_1 = require("../../filters/sitetext");
const ChallengeStatus_1 = require("../../enums/ChallengeStatus");
const IsotopeHeader_vue_1 = tslib_1.__importDefault(require("../IsotopeHeader.vue"));
const SlideHeaderWithNav_vue_1 = tslib_1.__importDefault(require("../SlideHeaderWithNav.vue"));
const ContainerSlide_vue_1 = tslib_1.__importDefault(require("../ContainerSlide.vue"));
const userTelemetry_1 = require("../../api/userTelemetry");
exports.default = vue_1.default.extend({
    name: 'create-user',
    data: () => {
        return {
            password: '',
            confirmPassword: '',
            invalidPassword: false,
            passwordMismatch: false,
            submitting: false,
        };
    },
    computed: {
        baseUrl() {
            return this.$store.state.configuration.baseUrl;
        },
        isMobile() {
            return this.$store.getters.isMobile;
        },
        buttonDisabled() {
            return this.password.length === 0 || this.confirmPassword.length === 0 || this.submitting || this.invalidPassword || this.passwordMismatch;
        },
        confirmPasswordErrorMessage() {
            if (this.confirmPassword.length > 0 && this.passwordMismatch) {
                return [this.getSiteText('Registration.CreateUser.PasswordDoesNotMatch')];
            }
            return [];
        },
        showConfirmPasswordMessage() {
            return this.confirmPassword.length > 0 && !this.passwordMismatch;
        },
        passwordRegex() {
            return this.$store.state.currentChallenge.PasswordRegex;
        },
        passwordStrengthEnabled() {
            return this.$store.state.currentChallenge.PasswordStrengthEnabled;
        },
        passwordStrengthMinLength() {
            return this.$store.state.currentChallenge.PasswordStrengthMinLength;
        },
        passwordMediumStrengthRegex() {
            return this.$store.state.currentChallenge.PasswordMediumStrengthRegex;
        },
        passwordStrongStrengthRegex() {
            return this.$store.state.currentChallenge.PasswordStrongStrengthRegex;
        },
        isLoading() {
            return this.submitting || this.$store.getters.isSyncing || this.$store.getters.isSubmittingAuthenticatedModel;
        },
    },
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    methods: {
        passwordStrengths() {
            return {
                'weak': this.getSiteText('Registration.CreateUser.PasswordStrength.Weak'),
                'fair': this.getSiteText('Registration.CreateUser.PasswordStrength.Fair'),
                'strong': this.getSiteText('Registration.CreateUser.PasswordStrength.Strong'),
            };
        },
        checkPasswordValid(password) {
            const passwordRegex = new RegExp(this.passwordRegex);
            this.invalidPassword = !passwordRegex.test(password);
            let inputUserName = this.$store.getters.username;
            if (this.password.includes(inputUserName)) {
                return this.getSiteText('Registration.CreateUser.PasswordIncludesUsername');
            }
            if (!this.invalidPassword)
                return;
            return this.getSiteText('Registration.CreateUser.PasswordDoesNotMeetRequirements');
        },
        checkPasswordStrength() {
            if (!this.passwordStrengthEnabled || this.password.length < this.passwordStrengthMinLength) {
                return 'none';
            }
            const strongRegex = new RegExp(this.passwordStrongStrengthRegex);
            if (strongRegex.test(this.password)) {
                return 'strong';
            }
            const fairRegex = new RegExp(this.passwordMediumStrengthRegex);
            if (fairRegex.test(this.password)) {
                return 'fair';
            }
            return 'weak';
        },
        checkPasswordMatches() {
            this.passwordMismatch = this.password !== this.confirmPassword;
        },
        async submitForm() {
            if (this.submitting) {
                return;
            }
            this.submitting = true;
            const telemetryPromise = userTelemetry_1.telemetry.custom({
                workflowName: userTelemetry_1.workflowName.retail_registration,
                stepType: userTelemetry_1.stepType.progression,
                stepName: userTelemetry_1.stepName.create_password,
                action: userTelemetry_1.userAction.create_password_clicked,
            });
            this.$store.commit('challengeStatus', ChallengeStatus_1.ChallengeStatus.Unknown);
            const challenge = {
                ...this.$store.state.currentChallenge,
                Password: this.password,
            };
            const createPasswordPromise = this.$store.dispatch('submitChallenge', challenge);
            // run async tasks in parallel
            await Promise.all([telemetryPromise, createPasswordPromise]);
            this.submitting = false;
        },
    },
    components: {
        SlideHeaderWithNav: SlideHeaderWithNav_vue_1.default,
        ContainerSlide: ContainerSlide_vue_1.default,
        IsotopeHeader: IsotopeHeader_vue_1.default,
    },
});
